// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__1HUr1","legacyBtn":"MutateMid_legacyBtn__25LQH"};